import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type UiState = {
  isShowPreloader: boolean;
  isShowInfoPopup: boolean;
};

const initialState: UiState = {
  isShowPreloader: false,
  isShowInfoPopup: false,
};

export const info = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setPreloader: (state, action: PayloadAction<UiState['isShowPreloader']>) => {
      state.isShowPreloader = action.payload;
    },
    setShowInfoPopup: (state, action: PayloadAction<UiState['isShowInfoPopup']>) => {
      state.isShowInfoPopup = action.payload;
    },
  },
});

export const { setPreloader, setShowInfoPopup } = info.actions;
export default info.reducer;
